(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form-bundle2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sisu-addon-gallery')) {
  customElements.define('sisu-addon-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.cards = Array.from(this.querySelectorAll('[data-addon-card]'));
      if (!this.cards.length) { this.hidden = true; return; }
      const track = this.querySelector('.sisu-gift-grid');
      this.querySelectorAll('[data-scroll]').forEach(button => {
        button.addEventListener('click', () => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({left:Number(button.dataset.scroll) * (this.cards[0].getBoundingClientRect().width + 16),behavior:reduced?'auto':'smooth'});
        }, options);
      });
      this.cards.forEach(card => {
        const toggle = card.querySelector('[data-toggle]');
        toggle.addEventListener('click', () => {
          const selected = toggle.getAttribute('aria-pressed') !== 'true';
          toggle.setAttribute('aria-pressed',String(selected));
          card.querySelector('[data-plus]').hidden = selected;
          card.querySelector('[data-tick]').hidden = !selected;
          this.updateCount();
        }, options);
        card.querySelector('[data-variant-select]')?.addEventListener('change', event => {
          const option = event.target.selectedOptions[0];
          card.dataset.variant = option.value;
          card.dataset.quantity = option.dataset.quantity;
          card.dataset.cents = option.dataset.cents;
          card.querySelector('[data-price]').textContent = '+ '+option.dataset.price;
          this.updateButtonPrices();
        }, options);
      });
      this.updateCount();
    }
    disconnectedCallback(){this.controller?.abort();}
    selectedCards(){return this.cards.filter(card=>card.querySelector('[data-toggle]').getAttribute('aria-pressed')==='true');}
    selectedTotal(){return this.selectedCards().reduce((sum,card)=>sum+Number(card.dataset.cents||0)*Number(card.dataset.quantity||1),0);}
    updateButtonPrices(){this.closest('.shopify-section')?.querySelectorAll('hdt-qty-price').forEach(price=>price.updatPrice?.());}
    updateCount(){
      const count=this.selectedCards().length;
      const summary=this.querySelector('[data-selected-summary]');
      summary.hidden=count===0;
      summary.textContent=this.dataset.summary.replace('[count]',String(count));
      this.updateButtonPrices();
    }
    prepareCartData(data){
      const selected=this.selectedCards();
      if(!selected.length || !data.get('id')) return;
      for(const [key,value] of Array.from(data.entries())){
        if(key==='id'||key==='quantity'||key==='selling_plan'){
          data.set('items[0]['+key+']',value);data.delete(key);
        }else if(key.startsWith('properties[')){
          data.append('items[0]['+key.replace('properties[','properties]['),value);data.delete(key);
        }
      }
      if(!data.has('items[0][quantity]')) data.set('items[0][quantity]','1');
      selected.forEach((card,index)=>{
        data.set('items['+(index+1)+'][id]',card.dataset.variant);
        data.set('items['+(index+1)+'][quantity]',card.dataset.quantity||'1');
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sisu-card-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sisu-card-message')) {
  customElements.define('sisu-card-message', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.message = this.querySelector('textarea');
      this.section = this.closest('.shopify-section');
      if (!this.message || !this.section) return;
      this.message.addEventListener('input', () => {this.querySelector('[data-status]').textContent='';this.sync();}, options);
      this.querySelector('[data-generate]').addEventListener('click', () => {
        if (this.message.value.trim() && !window.confirm(this.dataset.replace)) return;
        const recipient = this.querySelector('[data-recipient]').value.trim();
        const sender = this.querySelector('[data-sender]').value.trim();
        const select = this.querySelector('[data-occasion]');
        const selected = select.options[select.selectedIndex];
        this.message.value = [recipient,selected.dataset.message,sender].filter(Boolean).join('\n\n');
        this.sync();
        this.querySelector('[data-status]').textContent = this.dataset.generated;
        this.message.focus();
      }, options);
      this.querySelector('[data-clear]').addEventListener('click', () => {
        if (this.message.value.trim() && !window.confirm(this.dataset.replace)) return;
        this.message.value='';this.sync();this.message.focus();
        this.querySelector('[data-status]').textContent=this.dataset.cleared;
      }, options);
      this.section.addEventListener('submit', event => {
        if (event.target.matches('.hdt-main-product-form,.hdt-sticky-atc__form,.hdt-product-form-fbt')) this.sync();
      }, {...options,capture:true});
      this.sync();
    }
    disconnectedCallback() {this.controller?.abort();}
    sync() {
      const value = this.message.value;
      this.querySelector('[data-count]').textContent = value.length+' / 500';
      this.section.querySelectorAll('.hdt-sticky-atc__form,.hdt-product-form-fbt').forEach(form => {
        const bundle = form.classList.contains('hdt-product-form-fbt');
        const target = bundle ? form.querySelector('hdt-bundle-product') : form;
        if (!target) return;
        const name = bundle ? 'items[][properties][Card message]' : 'properties[Card message]';
        let field = Array.from(target.querySelectorAll('input')).find(input => input.name === name);
        if (!field) {field=document.createElement('input');field.type='hidden';field.name=name;target.append(field);}
        field.value=value;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sisu-delivery-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sisu-delivery-date')) {
  customElements.define('sisu-delivery-date', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dateInput = this.querySelector('input[type="date"]');
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.refreshMinimum();
      this.dateInput.addEventListener('focus', () => this.refreshMinimum(), options);
      this.dateInput.addEventListener('change', () => this.sync(), options);
      this.querySelector('[data-today]').addEventListener('click', () => {
        this.refreshMinimum();
        if (this.querySelector('[data-today]').disabled) return;
        this.dateInput.value = this.today();
        this.sync();
        this.dateInput.focus();
      }, options);
      this.section.addEventListener('submit', event => {
        if (!event.target.matches('.hdt-main-product-form,.hdt-sticky-atc__form,.hdt-product-form-fbt')) return;
        this.refreshMinimum();
        this.dateInput.setCustomValidity(this.dateInput.value && this.dateInput.value < this.dateInput.min ? this.dataset.invalid : '');
        if (!this.dateInput.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.scrollIntoView({behavior:'smooth',block:'center'});
          return;
        }
        this.sync();
      }, {...options,capture:true});
      this.sync();
      this.timer = setInterval(() => this.refreshMinimum(), 30000);
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); }
    clock() {
      const parts = new Intl.DateTimeFormat('en-AU', {timeZone:'Australia/Melbourne',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      const value = type => parts.find(part => part.type === type).value;
      return {date:value('year')+'-'+value('month')+'-'+value('day'),hour:Number(value('hour'))};
    }
    today() { return this.clock().date; }
    tomorrow(date = this.today()) {
      const next = new Date(date+'T12:00:00Z');
      next.setUTCDate(next.getUTCDate()+1);
      return next.toISOString().slice(0,10);
    }
    refreshMinimum() {
      const now = this.clock();
      const closed = now.hour >= 16;
      this.dateInput.min = closed ? this.tomorrow(now.date) : now.date;
      this.querySelector('[data-today]').disabled = closed;
      this.dateInput.setCustomValidity(this.dateInput.value && this.dateInput.value < this.dateInput.min ? this.dataset.invalid : '');
    }
    sync() {
      this.refreshMinimum();
      const date = this.dateInput.value;
      const service = date ? (date === this.today() ? this.dataset.sameDay : date === this.tomorrow() ? this.dataset.nextDay : this.dataset.scheduled) : '';
      this.querySelector('[data-service]').value = service;
      this.section.querySelectorAll('.hdt-sticky-atc__form,.hdt-product-form-fbt').forEach(form => {
        const bundle = form.classList.contains('hdt-product-form-fbt');
        const target = bundle ? form.querySelector('hdt-bundle-product') : form;
        if (!target) return;
        Object.entries({'Requested delivery date':date,'Requested delivery service':service}).forEach(([key,value]) => {
          const name = bundle ? 'items[][properties]['+key+']' : 'properties['+key+']';
          let input = Array.from(target.querySelectorAll('input')).find(item => item.name === name);
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; target.append(input); }
          input.value = value;
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sisu-funeral-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sisu-funeral-details')) {
  customElements.define('sisu-funeral-details', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.fields = Array.from(this.querySelectorAll('textarea[name]'));
      const options = {signal:this.controller.signal};
      this.addEventListener('input', () => this.sync(), options);
      this.section.addEventListener('submit', event => {
        if (event.target.matches('.hdt-main-product-form,.hdt-sticky-atc__form,.hdt-product-form-fbt')) this.sync();
      }, {...options,capture:true});
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    sync() {
      this.section.querySelectorAll('.hdt-sticky-atc__form,.hdt-product-form-fbt').forEach(form => {
        const bundle = form.classList.contains('hdt-product-form-fbt');
        const target = bundle ? form.querySelector('hdt-bundle-product') : form;
        if (!target) return;
        this.fields.forEach(source => {
          const name = bundle ? 'items[][' + source.name.replace('properties[','properties][') : source.name;
          let field = Array.from(target.querySelectorAll('input')).find(input => input.name === name);
          if (!source.value.trim()) { field?.remove(); return; }
          if (!field) { field=document.createElement('input');field.type='hidden';field.name=name;target.append(field); }
          field.value=source.value;
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
